import React from "react";

export default function MySQL_CHAR_LENGTH() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_CHAR_LENGTH</h1>
      <p>This is the MySQL_CHAR_LENGTH component generated from the SQL JSON.</p>
    </div>
  );
}
